import { render } from "./printed.vue?vue&type=template&id=666ce10c&scoped=true"
import script from "./printed.vue?vue&type=script&lang=js"
export * from "./printed.vue?vue&type=script&lang=js"

import "./printed.vue?vue&type=style&index=0&id=666ce10c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666ce10c"]])

export default __exports__